import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import HeaderStrip from '../../../components/Common/HeaderStrip';
import moment from 'moment';
import Select from "react-select";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const People = () => {

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedDesignation, setSelectedDesignation] = useState("");
    const [availabilityStatistics, setAvailabilityStatistics] = useState([]);
    const [mobAvailabiltyData, setMobAvailabiltyData] = useState([]);
    const [memberavailability, setMemberavailability] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [skills, setSkills] = useState([]);
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [showSessions, setShowSessions] = useState(false);
    const [mobFullName, setMobFullName] = useState('');
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    
    useEffect(() => {

        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        //cleanup function
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    var settings = {
        dots: false,
        arrows: true,
        speed: 500,
        slidesToShow: screenWidth < 640 ? 1 : screenWidth < 768 ? 2 : screenWidth < 1024 ? 3 : 4,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              initialSlide: 0,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              initialSlide: 0,
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 0,
            }
          }
        ]
      };
      
    const dispatch = useDispatch();

    const getMemberAvailabilityStatistics = async (start_date, end_date) => {
        start_date = moment(start_date).format('YYYY-MM-DD');
        end_date = moment(end_date).format('YYYY-MM-DD');
        const availabilityStatisticsData = await dispatch.people.memberavailabilityStatistics({
            start_date, end_date
        });
        if (availabilityStatisticsData && availabilityStatisticsData.success && availabilityStatisticsData.statistics) {
            setAvailabilityStatistics(availabilityStatisticsData.statistics);
        }
    }

    // session view in mobile
    const handleMobileSessions = async (nameId, firstName, lastName) => {
        const fullName = `${firstName} ${lastName}`
        setMobFullName(fullName);
        setMobAvailabiltyData(memberavailability.filter(data => data._id === nameId))
        setShowSessions(true)
    }

    const getMemberAvailabilityCalender = async (start_date, end_date) => {
        start_date = moment(start_date).format('YYYY-MM-DD');
        end_date = moment(end_date).format('YYYY-MM-DD');
        let skillsdata = selectedSkills.map(skillitem => {
            return skillitem.value
        });
        const memberAvailabilityData = await dispatch.people.memberAvailabilityCalender({
            start_date, end_date, designation: selectedDesignation && selectedDesignation.value, skills: skillsdata
        });

        if (memberAvailabilityData && memberAvailabilityData.success && memberAvailabilityData.useravailability) {
            setMemberavailability(memberAvailabilityData.useravailability);
        }

    }

    const getDesignationsList = async () => {
        const designationsData = await dispatch.projects.designationSearch({});
        if (designationsData && designationsData.data) {
            let filterdesigination = designationsData.data.filter(item => {
                return item.developerstatus === true;
            })
            setDesignations(filterdesigination);
        }
    }

    const getSkillList = async () => {
        const skillData = await dispatch.projects.skillsSearch({});
        if (skillData && skillData.data) {
            setSkills(skillData.data);
        }
    }

    const onChange = (dates) => {
        setStartDate("");
        setEndDate("");
        const [start, end] = dates;
        let currentDate = start;
        let firstday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
        let lastday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 5))
        setStartDate(firstday);
        setEndDate(lastday);
        getMemberAvailabilityStatistics(firstday, lastday);
        getMemberAvailabilityCalender(firstday, lastday);
        setShowSessions(false)
    };

    const isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    };



    useEffect(() => {
        const start = new Date();
        let currentDate = start;
        let firstday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 1));
        let lastday = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 5));
        setStartDate(firstday);
        setEndDate(lastday);
        //getPeopleListData();
        getMemberAvailabilityStatistics(firstday, lastday);
        getMemberAvailabilityCalender(firstday, lastday);
        getDesignationsList();
        getSkillList();

    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            getMemberAvailabilityCalender(startDate, endDate);
        }

    }, [selectedDesignation]);

    useEffect(() => {
        if (startDate && endDate) {
            getMemberAvailabilityCalender(startDate, endDate);
        }

    }, [selectedSkills]);

    const statistics = availabilityStatistics && availabilityStatistics.length > 0 && availabilityStatistics.map((availabilitystatisticsitem, ind) => {

        const dayStatistics = availabilitystatisticsitem.daywisetime.map((dayitem, dayind) => {

            return (
                <div key={dayind} className="h-full mr-1 inline-block relative" style={{ width: '28px' }}>
                    <div className="h-full bg-slate-300 w-3 relative mx-auto rounded-tl-sm rounded-tr-sm">
                        <span style={{ height: `${100 - dayitem.availabilitypercentageperday}%` }} className="w-3 inline-block rounded-tl-md rounded-tr-md bg-success absolute bottom-0"></span>
                    </div>
                    <span className="absolute text-xs  text-center left-0 right-0" style={{ bottom: "-20px" }}>
                        {dayitem && dayitem.date && moment(dayitem.date).format('ddd')}
                    </span>
                </div>);
        });

        return (
            <div key={ind} className="px-1">
                <div className="border p-5 pt-9 border-borderColor-100 rounded-md relative">

                    <div className="text-small font-semibold absolute left-0 top-0 bg-secondary-blue-300 py-1.5 px-2.5 rounded-tl-md rounded-br-md text-primary-navyBlue ">
                        {availabilitystatisticsitem.name} ({availabilitystatisticsitem.totaldevs})
                    </div>

                    <div className="grid grid-rows-2 grid-flow-col gap-1 ">
                        <div className="row-span-2 bg-secondary-blue-300 rounded p-3 flex">

                            <div className="w-full text-center">
                                <span className="text-xs font-medium ">Total</span>
                                <div className="flex items-center justify-center">
                                    <span className="text-lg font-bold text-primary-navyBlue">{availabilitystatisticsitem.totalweektimeforusers}</span>
                                    <span className="text-xs text-primary-navyBlue ml-1">hrs</span>
                                </div>
                            </div>

                            <div className="w-full text-center">
                                <div className="boder-l border-l-2 border-slate-300 pl-3 ml-3 ">
                                    <span className="text-xs font-medium">Booked</span>
                                    <div className="flex items-center justify-center">
                                        <span className="text-lg font-bold text-primary-navyBlue">{availabilitystatisticsitem.totalworkingsesssion}</span>
                                        <span className="text-xs text-primary-navyBlue ml-1">hrs</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="row-span-2 bg-primary-navyBlue rounded p-3 text-center flex items-center justify-center leading-3">
                            <div>
                                <span className="text-xs font-medium text-secondary-blue-300">Free Time</span>
                                <span className="block text-lg font-bold text-white">{availabilitystatisticsitem.totalweektimeforusers - availabilitystatisticsitem.totalworkingsesssion} hrs</span>
                            </div>
                        </div>

                    </div>

                    <div className="mt-4 flex flex-wrap items-center justify-evenly border-borderColor-100">

                        <div className="h-16">
                            {dayStatistics}
                        </div>

                        <div className="pie-parent rounded-full mt-0 md:mt-5">
                            <div style={{ '--p': `${100 - availabilitystatisticsitem.availabilitypercentage}`, '--c': '#1DBC6C' }} className={`pie animate no-round text-center`}>
                                <div className="pie-mask absolute rounded-full flex items-center justify-center" >
                                    <div className="booked-item text-small flex  items-center text-secondary">
                                        <span> <span className="block h-2.5 mt-1 font-light">Booked</span> <span className="block text-lg font-light" style={{ color: '#1DBC6C' }}>{(100 - availabilitystatisticsitem.availabilitypercentage).toFixed(2)}%</span></span>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    });



    const memberList = memberavailability && memberavailability.length > 0 && memberavailability.map((memberitem, ind) => {
        let availabletime = 0;

        const dateItem = memberitem && memberitem.availability && memberitem.availability.length > 0 && memberitem.availability.map((dateavailabilitiitem, dateind) => {
            availabletime = availabletime + 8;
            let sessionitem = null;

            if (!dateavailabilitiitem.project_id) {

                sessionitem = dateavailabilitiitem.availability_session.map((availabilitysessionitem, sessionind) => {

                    return (
                        <div key={sessionind} className="hidden sm:flex items-center justify-left bg-primary-blue-400 text-tiny font-medium my-0.5 rounded px-4 w-full h-10">
                            <div className=''>
                                <span className="block text-primary-secondary text-small font-medium">
                                    {availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}
                                </span>
                                <span className='text-primary text-xs font-bold'>
                                    Available
                                </span>
                            </div>
                        </div>
                    )
                }
                )

            } else {
                sessionitem = dateavailabilitiitem.availability_session.map((availabilitysessionitem, sessionind) => {

                    if (availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id._id) {
                        availabletime = availabletime - 4;

                        return (<div key={sessionind} className="hidden sm:flex items-center w-full justify-left bg-primary-navyBlue text-tiny font-medium my-0.5 rounded px-4 h-10  leading-tight">
                            <div>
                                <span className="block text-primary-blue-400 text-small font-medium">{availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}</span>
                                <span className='text-white text-xs font-bold'>{(availabilitysessionitem && availabilitysessionitem.project_id && availabilitysessionitem.project_id.name) || (dateavailabilitiitem && dateavailabilitiitem.project_id && dateavailabilitiitem.project_id.name)}</span>
                            </div>
                        </div>)

                    } else {

                        return (<div key={sessionind} className="hidden sm:flex items-center  w-full justify-left bg-primary-blue-400 text-tiny font-medium my-0.5 rounded px-4 h-10">
                            <div>
                                <span className="block text-primary-secondary text-small font-medium">{availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}</span>
                                <span className='text-primary text-xs font-bold'>Available</span>
                            </div>
                        </div>)
                    }
                });
            }


            return (<div key={dateind} className="border-t-0 border-r-0 sm:border-t sm:border-r h-full grid justify-items-center p-0 sm:p-1">
                {sessionitem}
            </div>)

        })


        return (
            <div key={ind} className="grid grid-cols-2 sm:grid-cols-7 gap-0 w-full">
                <div className="flex items-center border-t border-r p-4">

                <div className="block sm:hidden lg:block w-16">                        <div className="w-12 h-12 bg-secondary-blue-500 rounded-full mr-3 flex items-center justify-center">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.68649 9.90273V9.4416V8.46963V8.30907L9.75222 8.16258C9.84675 7.95192 9.92689 7.71831 9.9885 7.46067L10.0828 7.0664L10.4452 6.93614C10.4561 6.92603 10.4971 6.88571 10.5571 6.77367C10.6466 6.60666 10.7248 6.38047 10.7981 6.12172L10.7985 6.12043C10.8889 5.80309 10.9149 5.57967 10.909 5.43474C10.9055 5.34781 10.8917 5.30828 10.8866 5.29657L10.6584 5.03142L10.7232 4.67869C10.9677 3.34623 10.8075 2.59338 10.5264 2.22079C10.3903 2.04279 10.2423 1.97663 10.1544 1.9488L9.91658 1.87348L9.77124 1.67068C9.67694 1.5391 9.47085 1.29621 9.11238 1.09869L9.10221 1.09308L9.09221 1.08716C8.71857 0.865932 8.29257 0.75 7.80201 0.75C7.71731 0.75 7.62708 0.755036 7.53117 0.761429L7.52407 0.761903L7.51696 0.762242C7.31836 0.771699 7.11764 0.80908 6.9133 0.875252C6.90457 0.878401 6.89485 0.881725 6.88421 0.885081C6.66419 0.96263 6.44134 1.07624 6.2186 1.22823L6.20929 1.23458L6.19979 1.24065C5.93443 1.41026 5.69118 1.61267 5.4819 1.83555L5.47247 1.84559L5.47238 1.8455C5.06033 2.26847 4.80971 2.72216 4.70393 3.18219L4.70119 3.19409L4.69806 3.2059C4.59428 3.59827 4.58738 3.98725 4.67242 4.36993L4.77947 4.85169L4.37939 5.14063L4.37768 5.14194C4.37624 5.14505 4.37405 5.15034 4.37156 5.15847C4.3654 5.17866 4.357 5.21793 4.35544 5.28419C4.35216 5.42327 4.37966 5.63762 4.4692 5.95617L4.46941 5.95691C4.53433 6.18875 4.60102 6.38861 4.6756 6.54586C4.71209 6.62278 4.74554 6.67884 4.77405 6.71789C4.78792 6.73689 4.79922 6.74994 4.80742 6.75843C4.81534 6.76662 4.81954 6.76972 4.81957 6.76974L5.05863 6.94337L5.11502 7.23341C5.19287 7.63378 5.32185 7.98952 5.48951 8.29822L5.58044 8.46565V8.65617V9.44488V9.906L5.16896 10.1141C4.62479 10.3894 3.06636 11.2151 1.54379 12.3997L1.5437 12.3997C1.05069 12.7832 0.75 13.3951 0.75 14.0364V14.8873C0.75 15.0869 0.913491 15.25 1.1127 15.25H14.1542C14.3506 15.25 14.5169 15.0865 14.5169 14.884V14.0331C14.5169 13.3947 14.2159 12.7797 13.7233 12.3966L9.68649 9.90273ZM9.68649 9.90273L10.098 10.1109M9.68649 9.90273L10.098 10.1109M10.098 10.1109C10.6411 10.3856 12.2 11.2147 13.7232 12.3965L10.098 10.1109ZM4.37428 5.14466L4.37436 5.14458C4.3743 5.14464 4.37427 5.14466 4.37428 5.14466ZM6.99628 0.839667C6.9956 0.840008 6.99451 0.840548 6.99333 0.841132L6.99557 0.840024L6.99628 0.839667Z" stroke="white" strokeWidth="1.5"></path></svg>
                        </div>
                    </div>

                    <div className="hidden text-sm text-black font-medium sm:block">
                        {memberitem && memberitem.first_name} {memberitem && memberitem.last_name}
                    </div>
                    <div className="text-[12px] text-black font-medium block sm:hidden" onClick={() => { handleMobileSessions(memberitem._id, memberitem?.first_name, memberitem?.last_name) }}>
                        {memberitem && memberitem.first_name} {memberitem && memberitem.last_name}
                    </div>

                </div>

                {screenWidth >= 640 && dateItem}

                <div className="border-t border-r h-full grid justify-items-center p-1">
                    <div className="w-full bg-primary-blue-400 flex items-center justify-center text-primary text-xs font-bold">
                        {availabletime} Hours
                    </div>
                </div>

            </div>
        )

    });

    const headerDate = memberavailability && memberavailability.length > 0 && memberavailability[0] &&
        memberavailability[0].availability && memberavailability[0].availability.length > 0 && memberavailability[0].availability.map((dateitem, ind) => {
            return (<div key={ind} className="text-primary font-medium text-xs md:text-sm px-4 py-0 sm:py-2 "> {moment(dateitem.date).format('MMMM')} {moment(dateitem.date).format('DD')}</div >)
        });

    return (
        <>
            <HeaderStrip page="peoplePage" onChange={onChange} isWeekday={isWeekday} endDate={endDate} startDate={startDate} />
            <div className="px-6 pt-6 pb-6">
                <div className="w-full">
                    <Slider {...settings}>
                        {statistics}
                    </Slider>
                </div>
            </div>

            <div className="px-6">
                <div className="mb-4 block sm:flex flex-wrap items-center sm:justify-between">
                    <h3 className="text-md text-black font-medium inline-block mb-3 md:mb-0">Developers Availability</h3>
                    <div className="mr-2 relative w-auto">
                        <div className="block sm:flex w-full">
                            <Select
                                className='w-full sm:w-60 mb-3 text-xs mr-0 sm:mr-1 sm:text-base sm:mb-0 medium-selectbox appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear border rounded-md placeholder-secondary-grey-300 text-secondary-grey-300 font-normal border-secondary-grey-400 '
                                name="member"
                                value={selectedDesignation}
                                isSearchable={true}
                                isClearable={true}
                                options={designations.map((project) => ({ label: project.name, value: project._id }))}
                                placeholder="Select Designation"
                                classNamePrefix="dropdownSelect"
                                onChange={(e) => {
                                    setSelectedDesignation(e);
                                }}
                            />
                            <Select
                                className="medium-selectbox appearance-none ml-0 sm:ml-1 text-xs sm:text-base focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear border rounded-md w-full placeholder-secondary-grey-300 text-secondary-grey-300 font-normal border-secondary-grey-400 sm:w-60"
                                placeholder="Skills"
                                isMulti
                                classNamePrefix="dropdownSelect"
                                options={skills.map((project) => ({
                                    label: project.name,
                                    value: project._id,
                                }))}
                                onChange={(e) => {
                                    setSelectedSkills(e);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='hidden sm:block'>
                    <div className="border border-borderColor-100 mb-6 w-full overflow-x-scroll">
                        <div className="grid grid-cols-7 gap-0 justify-items-center md:justify-items-start items-center text-[12px] md:text-sm">
                            <div className="text-primary font-medium px-4 py-2">Full Name</div>
                            {headerDate}
                            <div className="text-primary font-medium px-4 py-2">Available Time</div>
                        </div>
                        {memberList.length > 0 ? memberList : <div className="text-center text-sm p-3">Loading...</div>}
                    </div>
                </div>

                <div className={`block sm:hidden`}>
                    <div className="border border-borderColor-100 w-full">
                        {
                            !showSessions &&
                            <div className="grid grid-cols-2 justify-around items-center text-[12px] text-primary w-full h-full font-medium ">
                                <div className="border-r h-8 flex items-center justify-center">
                                    <p>Full Name</p>
                                </div>
                                <div className="flex items-center justify-center h-8">
                                    <p>Available Time</p>
                                </div>
                            </div>

                        }

                        {
                            memberList.length > 0 ?
                                showSessions ?
                                    <div className='w-full h-fit mb-3 border bg-white'>
                                        <div className="flex items-center justify-between pl-3 pt-3 pb-3 pr-1">
                                            <p className='text-sm font-bold'>{mobFullName}</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => setShowSessions(false)} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 m-2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </div>

                                        {

                                            mobAvailabiltyData[0]?.availability?.map((dateavailabilitiitem, dateind) => {
                                                let sessionitem = null;

                                                if (!dateavailabilitiitem.project_id) {
                                                    sessionitem = dateavailabilitiitem.availability_session.map((availabilitysessionitem, sessionind) => {

                                                        return (
                                                            <div key={sessionind} className="flex items-center justify-left bg-primary-blue-400 text-tiny font-medium my-0.5 rounded px-4 w-full h-10">
                                                                <div className=''>
                                                                    <span className="block text-primary-secondary text-small font-medium">
                                                                        {availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}
                                                                    </span>
                                                                    <span className='text-primary text-xs font-bold'>
                                                                        Available
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    )

                                                } else {
                                                    sessionitem = dateavailabilitiitem.availability_session.map((availabilitysessionitem, sessionind) => {

                                                        if (availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id._id) {

                                                            return (
                                                                <div key={sessionind} className="flex items-center w-full justify-left bg-primary-navyBlue text-tiny font-medium my-0.5 rounded px-4 h-10 leading-tight">
                                                                    <div>
                                                                        <span className="block text-primary-blue-400 text-small font-medium">{availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}</span>
                                                                        <span className='text-white text-xs font-bold'>{(availabilitysessionitem && availabilitysessionitem.project_id && availabilitysessionitem.project_id.name) || (dateavailabilitiitem && dateavailabilitiitem.project_id && dateavailabilitiitem.project_id.name)}</span>
                                                                    </div>
                                                                </div>
                                                            )

                                                        } else {

                                                            return (<div key={sessionind} className="flex items-center w-full justify-left bg-primary-blue-400 text-tiny font-medium my-0.5 rounded px-4 h-10">
                                                                <div>
                                                                    <span className="block text-primary-secondary text-small font-medium">{availabilitysessionitem && availabilitysessionitem.session_id && availabilitysessionitem.session_id.session_name}</span>
                                                                    <span className='text-primary text-xs font-bold'>Available</span>
                                                                </div>
                                                            </div>)
                                                        }
                                                    });
                                                }

                                                return (
                                                    <div key={dateind} className="flex items-center justify-around m-3">
                                                        <p className='text-sm font-bold'>{moment(dateavailabilitiitem.date).format('MMMM DD')}</p>
                                                        <div className='flex w-[70%] space-x-4'>
                                                            {sessionitem}
                                                        </div>
                                                    </div>
                                                )

                                            })

                                        }
                                    </div>
                                    :
                                    memberList
                                :
                                <div className="text-center text-sm p-3">Loading...</div>
                        }
                    </div>
                </div>

            </div >
        </>
    )



}

export default People

